import React from 'react';
import GraphPlaceHolder from '@ui/placeholder/GraphPlaceHolder';


export const EmptyGraphPlaceholder = React.memo(() => {

	return <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			<GraphPlaceHolder />
		</div>
});

